import { render, staticRenderFns } from "./ux-info-icon.vue?vue&type=template&id=048ad673&scoped=true"
import script from "./ux-info-icon.vue?vue&type=script&lang=js"
export * from "./ux-info-icon.vue?vue&type=script&lang=js"
import style0 from "./ux-info-icon.vue?vue&type=style&index=0&id=048ad673&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ad673",
  null
  
)

export default component.exports